import React, { useEffect, useState } from "react";
import useHover from "../hooks/useHover";

const DetailedButton = ({
  description,
  onButtonClicked,
  name,
  fontSize,
  backgroundColor,
  image,
  width = "60%",
  player,
  activeButton,
  boxType,
  id,
}) => {
  const hover = useHover();
  const [isActive, setIsActive] = useState(false);
  const [text, setText] = useState("Put in Active");

  useEffect(() => {
    const inActive =
      (player?.active?.box?.id == id || player?.active.goal?.id == id) &&
      description != "Open goal";

    setText(inActive ? "Is Active" : description);
    setIsActive(inActive);
  }, [player]);

  return (
    <button
      onClick={() => {
        onButtonClicked(name);
      }}
      {...hover.divProps}
      className="divRow"
      style={{
        cursor: isActive ? null : "pointer",
        marginTop: "5px",
        height: "30px",
        width,
        cursor: isActive ? null : "pointer",
        backgroundColor: hover.hover
          ? "#7f7f7f"
          : isActive
          ? "#7f7f7f"
          : backgroundColor,
        justifyContent: "center",
        borderRadius: ".5rem/.5rem",
      }}
    >
      {!isActive && <img src={image} className="icon25" />}
      <div
        className="textBoldWhite"
        style={{
          flex: 1,
          fontSize: `${fontSize}px`,
          color: hover.hover && !isActive ? "gold" : "white",
        }}
      >
        {text}
      </div>
    </button>
  );
};

export default DetailedButton;
